import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-fortnite', 'BrandFortnite', [["path",{"d":"M8 3h7.5l-.5 4h-3v3h3v3.5h-3v6.5l-4 1l0 -18","key":"svg-0"}]]);